<template>
  <layout-no-padding>
    <transition name="fadeToggle" mode="out-in">
      <v-flex xs12>
        <v-card hover>
          <v-card-title class="flex-container-space-between vertical-center-container pb-0">
            Billing Periods
            <v-btn @click="addDialog = true" flat :color="$store.state.global.pages.settings.color">
              <v-icon left>add</v-icon>Create Billing Period
            </v-btn>
          </v-card-title>
          <v-flex>
            <v-data-table
              :items="billingPeriods"
              :headers="headers"
              :rows-per-page-items="pageOptions"
              :loading="loading"
              disable-initial-sort
            >
              <template slot="no-data">
                <div class="text-xs-center grey--text subheading">No billing periods found.</div>
              </template>
              <template slot="items" slot-scope="props">
                <billing-period-row :row="props.item" :headers="headers"></billing-period-row>
              </template>
            </v-data-table>
          </v-flex>
        </v-card>

        <!-- ADD DIALOG -->
        <v-dialog v-model="addDialog" max-width="700px" @keydown.esc="addDialog = false" lazy>
          <add-billing-period @close="addDialog = false"></add-billing-period>
        </v-dialog>
      </v-flex>
    </transition>
  </layout-no-padding>
</template>

<script>
import Store from '@/store/computed/storeHelpers'

// COMPONENTS
import BillingPeriodRow from '@/modules/settings/billingPeriods/billingPeriodRow'
import AddBillingPeriod from '@/modules/settings/billingPeriods/addBillingPeriod'

// MIXINS
import FormatDates from '@/services/mixins/formatDates'
import BillingPeriods from '@/services/mixins/billingPeriods'

export default {
  mixins: [FormatDates, BillingPeriods],
  components: {
    BillingPeriodRow,
    AddBillingPeriod
  },
  data() {
    return {
      addDialog: false,
      headers: [
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Open',
          value: 'isOpen'
        },
        {
          text: 'Actions',
          align: 'right',
          value: '',
          sortable: false
        }
      ],
      loading: false,
      pageOptions: [10, 20, 40]
    }
  }
}
</script>

<style scoped>
</style>
